"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsLti = void 0;
var _reactRedux = require("react-redux");
// This hook is used to determine if the LTI Assignments feature is enabled for the current user's organization.
var useIsLti = function useIsLti() {
  var selectedOrganizationId = (0, _reactRedux.useSelector)(function (store) {
    return store.session.get('selected_organization_id');
  });
  var organizationLtiEnabled = (0, _reactRedux.useSelector)(function (store) {
    return store.organizations;
  }).getIn([selectedOrganizationId, 'lti_enabled']);
  return organizationLtiEnabled;
};
exports.useIsLti = useIsLti;